import { createStore, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';

// Import reducers from modules
import usersReducer from './modules/user/reducers';
import patientReducer from './modules/patient/reducers';
import toastReducers from './modules/toast/reducers';
import clinicalServiceReducer from './modules/clinical-services/reducers';
import medicalSummaryReducer from './modules/medical-summary/reducer';
import interventionReducer from './modules/intervention/reducers';
import medicationsReducer from './modules/medications/reducer';
// ...

// Combine reducers
const rootReducer = combineReducers({
  users: usersReducer,
  patients: patientReducer,
  toast:toastReducers,
  clinicalService:clinicalServiceReducer,
  medicalSummary: medicalSummaryReducer,
  intervention: interventionReducer,
  medications: medicationsReducer,
  userDetailsLoading: usersReducer,
  updateLegalContentLoading: usersReducer,
  currentLoggedInUserDetail: usersReducer,
  currentUserRoles: usersReducer,
  companyRoles: usersReducer,
  roles: usersReducer,
  permissions: usersReducer,
  // ...
});

const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;